import { render, staticRenderFns } from "./batchOrders.vue?vue&type=template&id=c855e8d6"
import script from "./batchOrders.vue?vue&type=script&lang=js"
export * from "./batchOrders.vue?vue&type=script&lang=js"
import style0 from "./batchOrders.vue?vue&type=style&index=0&id=c855e8d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports